import axios from 'axios'

export const env = (KEY) => process.env[`REACT_APP_${KEY}`]

const dau = axios.create({
  baseURL: env('API_URL_DAU'),
  headers: {
    api_key_header: env('API_KEY_DAU'),
  },
})

const simulatorAxiosInstance = axios.create({
  baseURL: env('API_URL_SIMULATOR'),
  headers: {
    api_key_header: env('API_KEY_SIMULATOR'),
  },
})

const indicatorsAxiosInstance = axios.create({
  baseURL: env('API_URL_INDICATORS'),
  headers: {
    api_key_header: env('API_KEY_INDICATORS'),
  },
})

const odooCrm = axios.create({
  baseURL: env('API_URL_ODOO_CONTACTS'),
  headers: {
    'x-api-key': env('API_KEY_ODOO_CONTACTS'),
  },
})

export { dau, simulatorAxiosInstance, indicatorsAxiosInstance, odooCrm }
